import React, { useEffect, useRef, useState } from "react";

const EmojiWrapper = React.memo(({ handleEmoji, iconsSize = "large", chatView, message, cursorPositionRef }) => {
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
  const emojiPickerContainerRef = useRef(null);
  const [emojiPickerData, setEmojiPickerData] = useState();
  const messageRef = useRef(message);

  useEffect(() => {
    messageRef.current = message;
  }, [message]);

  const icon = <div data-cy="emoji" className={`${iconsSize === "small" ? "hs-scale-0-8" : ""} actionIconsSprite emojiIcon`} />;
  useEffect(() => {
    if (isEmojiPickerOpen) {
      fetch("https://cdn.jsdelivr.net/npm/@emoji-mart/data") // This cdn could be replaced by hosting our own cdn
        .then((res) =>
          res.json().then(async (responseJson) => {
            setEmojiPickerData(responseJson);
          })
        );
    }
  }, [isEmojiPickerOpen]);

  const constructEmojiAndMessage = (emoji, event) => {
    const updatedMessage =
      messageRef.current?.slice(0, cursorPositionRef?.current) + emoji?.native + messageRef.current?.slice(cursorPositionRef?.current);
    cursorPositionRef.current = cursorPositionRef?.current + emoji?.native?.length;
    handleEmoji(updatedMessage, event, "emojis");
  };

  useEffect(() => {
    if (emojiPickerData) {
      createPicker();
    }
   
  }, [emojiPickerData]);

  const createPicker = () => {
    import("emoji-mart").then(
      ({ Picker }) =>
        new Picker({
          data: emojiPickerData,
          open: isEmojiPickerOpen,
          parent: emojiPickerContainerRef.current,
          theme: "light",
          onEmojiSelect: constructEmojiAndMessage,
          onClickOutside: () => setIsEmojiPickerOpen(false),
          perLine: chatView ? 6 : 9,
          previewPosition: "none",
          maxFrequentRows: 2,
        })
    );
  };

  return (
    <>
      <div onClick={() => setIsEmojiPickerOpen((prev) => !prev)}>{icon}</div>
      {isEmojiPickerOpen && (
        <div className="position-absolute z-1">
          <div className="position-absolute bottom-0 customSelectPopup" ref={emojiPickerContainerRef} />
        </div>
      )}
    </>
  );
});

export default EmojiWrapper;
